export const about = {
  hero: {
    home: 'Accueil',
    aboutUs: 'À Propos',
    title: 'À Propos d\'EINA',
    intro: 'Ste EINA Ltd est un fournisseur leader de technologies avancées de séparation et de purification, spécialisé dans des solutions de filtration complètes pour diverses applications industrielles au Cameroun et en Afrique.',
    paragraph1: 'Notre équipe d\'ingénieurs expérimentés combine une expertise scientifique approfondie avec une connaissance pratique industrielle pour fournir des solutions personnalisées qui optimisent la performance des processus, améliorent la qualité des produits et réduisent les coûts opérationnels.',
    paragraph2: 'Grâce à des partenariats stratégiques avec des fabricants de classe mondiale et une innovation continue dans les technologies de filtration, nous veillons à ce que nos clients reçoivent les systèmes et médias de purification les plus efficaces et fiables pour leurs besoins spécifiques.',
  },
  journey: {
    title: 'Notre Parcours',
    subtitle: 'Bâtir l\'excellence dans la filtration industrielle grâce à l\'innovation continue et l\'engagement envers le succès de nos clients',
    milestones: [
      {
        year: '2014',
        title: 'Fondation de l\'Entreprise',
        description: 'Ste EINA Ltd créée avec la vision de fournir des solutions de filtration avancées aux clients industriels',
        image: 'https://readdy.ai/api/search-image?query=modern%20industrial%20company%20founding%20moment%20with%20professional%20team%20and%20advanced%20filtration%20equipment%20in%20clean%20facility%20showing%20innovation%20and%20expertise%20with%20green%20and%20white%20tones&width=400&height=300&seq=milestone-001&orientation=landscape',
      },
      {
        year: '2016',
        title: 'Partenariats Mondiaux',
        description: 'Alliances stratégiques formées avec des fabricants internationaux leaders en technologie de filtration',
        image: 'https://readdy.ai/api/search-image?query=international%20business%20partnership%20handshake%20with%20global%20industrial%20equipment%20and%20world%20map%20background%20showing%20collaboration%20and%20trust%20in%20professional%20corporate%20setting&width=400&height=300&seq=milestone-002&orientation=landscape',
      },
      {
        year: '2018',
        title: 'Expansion Technologique',
        description: 'Portefeuille élargi pour inclure une gamme complète de technologies de filtration membranaire et en profondeur',
        image: 'https://readdy.ai/api/search-image?query=advanced%20membrane%20filtration%20technology%20laboratory%20with%20modern%20equipment%20and%20scientific%20instruments%20showing%20technological%20innovation%20and%20research%20development%20in%20clean%20professional%20environment&width=400&height=300&seq=milestone-003&orientation=landscape',
      },
      {
        year: '2022',
        title: 'Reconnaissance de l\'Industrie',
        description: 'Certification ISO et reconnaissance en tant que fournisseur de confiance dans plusieurs secteurs industriels',
        image: 'https://readdy.ai/api/search-image?query=ISO%20certification%20award%20and%20quality%20recognition%20with%20professional%20industrial%20facility%20background%20showing%20excellence%20and%20achievement%20in%20clean%20modern%20setting%20with%20green%20accents&width=400&height=300&seq=milestone-004&orientation=landscape',
      },
    ],
  },
  missionVision: {
    title: 'Notre Fondation',
    subtitle: 'Guidés par des principes clairs et un engagement inébranlable envers l\'excellence',
    mission: {
      title: 'Mission',
      description: 'Fournir des solutions de filtration et de purification avancées qui optimisent les processus industriels, améliorent la qualité des produits et favorisent l\'excellence opérationnelle pour nos clients au Cameroun et en Afrique.',
    },
    vision: {
      title: 'Vision',
      description: 'Devenir le leader mondial dans les technologies de séparation industrielle, reconnu pour l\'innovation, l\'expertise technique et l\'engagement inébranlable envers le succès des clients et la durabilité environnementale.',
    },
    values: {
      title: 'Valeurs',
      description: 'Innovation, Excellence Technique, Fiabilité, Durabilité, Optimisation des Coûts, Partenariat Client, Amélioration Continue et Pratiques Commerciales Éthiques.',
    },
    valuesInAction: 'Nos Valeurs Fondamentales en Action',
    innovation: 'Innovation',
    excellence: 'Excellence',
    reliability: 'Fiabilité',
    sustainability: 'Durabilité',
    costOptimization: 'Optimisation des Coûts',
    partnership: 'Partenariat',
    improvement: 'Amélioration',
    ethics: 'Éthique',
  },
  expertise: {
    title: 'Expertise Technique',
    subtitle: 'Combiner les connaissances scientifiques avec l\'expérience industrielle pratique pour fournir des solutions optimales',
    scientificApproach: 'Approche Scientifique & Excellence Technique',
    scientificDesc1: 'Notre équipe d\'ingénieurs et de spécialistes en filtration expérimentés apporte des décennies d\'expertise combinée dans les technologies de séparation. Nous appliquons une méthodologie scientifique rigoureuse pour analyser les besoins des processus, identifier les solutions optimales et mettre en œuvre des systèmes qui offrent des améliorations de performance mesurables.',
    scientificDesc2: 'Grâce à une compréhension approfondie de la dynamique des fluides, de la science des membranes et des processus industriels, nous concevons des systèmes de filtration personnalisés qui répondent aux défis spécifiques tout en optimisant l\'efficacité, la qualité des produits et les coûts opérationnels.',
    customization: 'Personnalisation & Flexibilité',
    customizationDesc1: 'Chaque application industrielle présente des exigences uniques. Nous excellons dans le développement de solutions sur mesure qui s\'intègrent parfaitement aux processus existants, respectent les contraintes spécifiques et évoluent pour répondre aux demandes de production changeantes.',
    customizationDesc2: 'Notre approche flexible garantit que, que vous ayez besoin d\'un système clé en main complet ou d\'améliorations de processus ciblées, nous fournissons des solutions qui s\'alignent parfaitement avec vos objectifs opérationnels et vos paramètres budgétaires.',
    continuousImprovement: 'Amélioration Continue des Processus',
    continuousDesc: 'Nous maintenons des partenariats continuels avec nos clients, fournissant un support technique, un suivi des performances et des recommandations d\'optimisation pour assurer une excellence soutenue. Notre engagement dépasse l\'installation initiale pour englober l\'amélioration des processus et le succès opérationnel à long terme.',
    keyCompetencies: 'Compétences Clés',
    membraneTechnology: 'Technologie à Membrane',
    processEngineering: 'Ingénierie des Processus',
    industrialApplications: 'Applications Industrielles',
    technicalConsulting: 'Conseil Technique',
    systemIntegration: 'Intégration des Systèmes',
    qualityAssurance: 'Assurance Qualité',
    certificationsTitle: 'Certifications & Normes de Qualité',
    iso9001: 'ISO 9001:2015',
    qualityManagement: 'Management de la Qualité',
    iso14001: 'ISO 14001',
    environmentalManagement: 'Management Environnemental',
    industryCertified: 'Certifié par l\'Industrie',
    technicalExcellence: 'Excellence Technique',
  },
  international: {
    title: 'Présence Internationale',
    subtitle: 'Des partenariats stratégiques avec des fabricants mondiaux leaders garantissent qualité, disponibilité et support complet',
    globalPartnerNetwork: 'Réseau de Partenaires Mondial',
    globalDescription: 'Servir des clients dans le monde entier grâce à des partenariats internationaux stratégiques',
    globalNetwork: 'Réseau Mondial',
    supplyContinuity: 'Continuité d\'Approvisionnement',
    localSupport: 'Support Local',
    qualityAssurance: 'Assurance Qualité',
    globalNetworkDesc: 'Accès à des capacités de fabrication et de distribution mondiales',
    supplyContinuityDesc: 'Disponibilité des produits garantie et livraisons fiables',
    localSupportDesc: 'Assistance technique et service dans votre région',
    qualityAssuranceDesc: 'Normes internationales et processus de fabrication certifiés',
    readyToWork: 'Prêt à Travailler Ensemble ?',
    readyDescription: 'Découvrez comment notre réseau mondial et notre expertise technique peuvent optimiser vos processus industriels',
    requestStudy: 'Demander une Étude Technique',
    contactUs: 'Contactez-nous',
  },
};